import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('app-collapse', AppCollapse)
Vue.component('app-collapse-item', AppCollapseItem)

